// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2f3Vh4oePS9-MoXCpmPgb7"};